export default "__VITE_ASSET__CHfXdEO9__"